import { fetchPagesSuccess } from 'actions/brand_page_actions';

const refreshPagesService = (context, pages) => {
  const { dispatch, pageParentType } = context;

  dispatch(fetchPagesSuccess(pages, pageParentType));
};

export default refreshPagesService;
